import About from './About';
import Header from './Header';
import Icons from './Icons';
import Projects from './Projects';

import { ClipLoader } from 'react-spinners';
import { useEffect, useState } from "react";
import database from './../firebase.js';
import { getDatabase, ref, child, get } from "firebase/database";

const Main = () => {

    const [data, setData] = useState([]);
    const [isLoading, setIsLoading] = useState(true);


    useEffect(() => {
        const timer = setTimeout(() => {
          setIsLoading(false);
        }, 2000); // 2000 milliseconds = 2 seconds
    
        // Cleanup the timer if the component unmounts
        return () => clearTimeout(timer);
      }, []);
    

    useEffect(() => {

        const dbRef = ref(getDatabase());
        get(child(dbRef, `portfolio`)).then((snapshot) => {
            if (snapshot.exists()) {
                //console.log(snapshot.val());
                setData(snapshot.val());
            } else {
                console.log("No data available");
            }
        }).catch((error) => {
            console.error(error);
        });

    }, []);

    //console.log(data)

    if (isLoading) {
        return (
            <main className='bg-dark'>
                <div className="spinner-container">
                    <ClipLoader color="#123abc" loading={isLoading} size={80} />
                </div>
            </main>
        ) 
    }

    return (
        <>
            <main className='container py-4'>
                <Header />
                <Icons />
                <div className='container two-col'>
                    <div className='row column-gap-3'>
                        <About about={data[0].about } />
                        <Projects projects={data[1].projects} />
                    </div>
                </div>
            </main>
        </>
    )
}


export default Main;